import Name from "./name";
import Countries from "./countries";

export default function Details() {
  return (
    <div className="grid grid-cols-12 gap-4">
      <div className="col-span-12">
        <Name />
      </div>
      <div className="col-span-12">
        <Countries />
      </div>
    </div>
  );
}
